import { HandoverType } from '../src/app/interfaces/handover-type';

export const HANDOVER_TYPES: HandoverType[] = [
  { handoverTypeId: 1, name: 'HO1' },
  { handoverTypeId: 2, name: 'HO2' },
  { handoverTypeId: 3, name: 'HO3' },
  { handoverTypeId: 4, name: 'HO4' },
  { handoverTypeId: 5, name: 'HO5' },
];
